import classnames from "classnames";
import React from "react";
import Rail from "web/react/components/rail/rail";
import AjaxRelatedSearchProductImages from "web/react/components/related-searches-rail/ajax-related-search-product-images";
import RelatedSearchProductImages from "web/react/components/related-searches-rail/related-search-product-images";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import styles from "./related-designers-rail.css";

interface RelatedDesignersRailProps {
    title?: string;
    designers: any[];
    features: any;
    eventCategory?: string;
    className?: string;
}

function RelatedDesignersRail({
    title,
    designers,
    features,
    eventCategory,
    className,
}: RelatedDesignersRailProps): JSX.Element {
    function handleClick(): void {
        if (eventCategory) {
            analytics.event(eventCategory, "pdp_related_click", "related_designer_clicked");
        }
    }

    const batchCacheEnabled = environment.getFeature(
        "seo_enable_batched_cache_for_related_designers"
    );
    const anchorTagImageEnabled =
        environment.getFeature("seo_is_pdp_related_designer_subcategory_only") ||
        environment.getFeature("seo_oos_pdp_related_designer_subcategory_only");
    return (
        <Rail
            title={title}
            analyticsLabel={"related_designers"}
            className={classnames(className, styles.railWrapper)}
            peekingCard={features.uj_peeking_card}
        >
            {designers.map((designer) => (
                <div key={designer.url} className={styles.cardWrapper}>
                    <div className={styles.designerCard}>
                        {anchorTagImageEnabled ? (
                            <div onClick={handleClick}>
                                {batchCacheEnabled ? (
                                    <RelatedSearchProductImages images={designer.images} />
                                ) : (
                                    <AjaxRelatedSearchProductImages feedUrl={designer.url} />
                                )}
                            </div>
                        ) : (
                            <a href={designer.url} onClick={handleClick}>
                                {batchCacheEnabled ? (
                                    <RelatedSearchProductImages images={designer.images} />
                                ) : (
                                    <AjaxRelatedSearchProductImages feedUrl={designer.url} />
                                )}
                            </a>
                        )}
                        <a
                            href={designer.url}
                            className={styles.designerName}
                            onClick={handleClick}
                        >
                            {designer.name}
                        </a>
                    </div>
                </div>
            ))}
        </Rail>
    );
}

export default RelatedDesignersRail;
